
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DatePickerComponent } from './directives/datePicker/datePicker.component';
import { FormsModule } from '@angular/forms';
import { DateFormPipe } from '../shared/date-format-pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectBoxComponent } from './directives/select-box/select-box.component';
import { MultiSelectBoxComponent } from './directives/multi-select-box/multi-select-box.component';
import { CommonModalComponent } from './modal/common-modal/common-modal.component';
import { DateOfBirthComponent } from './directives/date-of-birth/date-of-birth.component';
import { DateInputComponent } from './directives/date-inp/date-inp.component';
import { TranslateModule } from '@ngx-translate/core';
import { PhoneNumberComponent } from './directives/phone-number/phone-number.component';
import { FormDatePipe } from './pipes/form-date-pipe';
import { NumberOnlyDirective } from './directives/number.directive';
import { NumberFormDirective } from './directives/number-form-directive';
import { ConsulnumDirective } from './directives/consul-num.directive';
import { DateFormatDirective } from './directives/dateFm.directive';
import { SafeHtmlPipe } from './pipes/safe-html-pipe';
import { PostalFormDirective } from './directives/postal-code-directive';
import { FullDateFormatPipe } from '../shared/full-date-format-pipe';
import { CurrrencyFormatPipe } from '../shared/currency-format-pipe';
import { TimePipe } from '../shared/pipes/time-format-pipe';
import { InpQuantitativeComponent } from './directives/inp-quantitative/inp-quantitative.component';
import { InpSiteFindingComponent } from './directives/inp-site-finding/inp-site-finding.component';
import { OneTimeDirective } from './directives/bind-one-time.directive';
import { SelectPartComponent } from './directives/select-part/select-part.component';
import { SelectOpinionComponent } from './directives/select-opinion/select-opinion.component';
import { CalendarComponent } from './directives/calendar/calendar.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectCommonComponent } from './directives/select-common/select-common.component';
import { FilterBoxComponent } from './directives/filter-box/filter-box.component';
import { ExportFormMultiSelectBoxComponent } from './export-form-multi-select-box/export-form-multi-select-box.component';
import { AlphaNumericDirective } from './directives/alphanumeric.directive';
import { IconWarningComponent } from './directives/icon-warning/icon-warning.component';
import { InpPostalCodeComponent } from './directives/inp-postal-code/inp-postal-code.component';
import { DateFormatLanguagePipe } from '../shared/directives/date-format-language';
import { PhoneNumberFormat } from '../shared/phone-number-format';
import { PostalCodeFormat } from '../shared/postal-code-format';
@NgModule({
    declarations: [
        DatePickerComponent,
        DateFormPipe,
        SelectBoxComponent,
        MultiSelectBoxComponent,
        CommonModalComponent,
        PhoneNumberComponent,
        DateOfBirthComponent,
        DateInputComponent,
        FormDatePipe,
        NumberOnlyDirective,
        NumberFormDirective,
        ConsulnumDirective,
        DateFormatDirective,
        SafeHtmlPipe,
        PostalFormDirective,
        FullDateFormatPipe,
        CurrrencyFormatPipe,
        TimePipe,
        InpQuantitativeComponent,
        InpSiteFindingComponent,
        OneTimeDirective,
        SelectPartComponent,
        SelectOpinionComponent,
        CalendarComponent,
        SelectCommonComponent,
        FilterBoxComponent,
        ExportFormMultiSelectBoxComponent,
        AlphaNumericDirective,
        IconWarningComponent,
        InpPostalCodeComponent,
        DateFormatLanguagePipe,
        PhoneNumberFormat,
        PostalCodeFormat,
    ],
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule.forRoot(),
        NgSelectModule,
        TranslateModule,
        NgbDatepickerModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        DatePickerComponent,
        SelectBoxComponent,
        MultiSelectBoxComponent,
        CommonModalComponent,
        DateOfBirthComponent,
        DateInputComponent,
        TranslateModule,
        PhoneNumberComponent,
        FormDatePipe,
        NumberOnlyDirective,
        NumberFormDirective,
        ConsulnumDirective,
        DateFormatDirective,
        CommonModalComponent,
        FullDateFormatPipe,
        PostalFormDirective,
        SafeHtmlPipe,
        CurrrencyFormatPipe,
        TimePipe,
        InpQuantitativeComponent,
        InpSiteFindingComponent,
        OneTimeDirective,
        CalendarComponent,
        SelectCommonComponent,
        FilterBoxComponent,
        ExportFormMultiSelectBoxComponent,
        AlphaNumericDirective,
        IconWarningComponent,
        InpPostalCodeComponent,
        DateFormatLanguagePipe,
        PhoneNumberFormat,
        PostalCodeFormat,
    ]
})

export class SharedModule {

}
